import PerfectScrollbar from 'perfect-scrollbar';
jQuery(function ($) {
	if ($('.scrollable-y').length) {
		const ps = new PerfectScrollbar('.scrollable-y', {
        wheelSpeed: 2,
        // wheelPropagation: false,
        minScrollbarLength: 20,
        scrollingThreshold: 5000,
        suppressScrollX: true,
        swipeEasing: true,
      });
    }
    if ($('.scrollable-y-2').length) {
      const ps2 = new PerfectScrollbar('.scrollable-y-2', {
        wheelSpeed: 2,
        // wheelPropagation: false,
        minScrollbarLength: 20,
        scrollingThreshold: 5000,
        suppressScrollX: true,
        swipeEasing: true,
      });
	}
    if ($('.scrollable-x').length) {
      const ps2 = new PerfectScrollbar('.scrollable-x', {
        wheelSpeed: 2,
        // wheelPropagation: false,
        minScrollbarLength: 20,
        scrollingThreshold: 5000,
        suppressScrollY: true,
        swipeEasing: true,
      });
	}
    if ($('.perfect-scroll').length) {
      const ps = new PerfectScrollbar('.perfect-scroll', {
        wheelSpeed: 2,
        // wheelPropagation: false,
        minScrollbarLength: 20,
        scrollingThreshold: 5000,
        swipeEasing: true,
      });
	}
    if ($('.breadcrumbs').length) {
      const ps = new PerfectScrollbar('.breadcrumbs', {
        wheelSpeed: 2,
        // wheelPropagation: false,
        minScrollbarLength: 20,
        scrollingThreshold: 5000,
        swipeEasing: true,
      });
	}
  if ($('.show-search-result-box').length) {
    var ps = new PerfectScrollbar('.show-search-result-box');
  }
});
